module.exports = __webpack_public_path__ + "img/part-2-title.4aa7f0ce.png";